import { useQuery } from "@tanstack/react-query"

import { backendUrl } from "../../lib/client"

export const useTalkJS = () => {
  const bearer = window.localStorage.getItem("medusa_auth_token") || ""
  const init = { headers: { authorization: `Bearer ${bearer}` } }
  const { data: talkJs, isLoading } = useQuery({
    queryKey: ["talk-js"],
    queryFn: () =>
      fetch(`${backendUrl.replace(/\/$/, "")}/vendor/talkjs/config`, init)
        .then((res) => res.json())
        .catch((err) => {
          message: err
        }),
  })

  return { ...talkJs, isLoading }
}
